import { ReactElement } from "react";
import { SetupStepData } from "../Setup/types";
import { getScheduleDisplayValue } from "../../utils";
import { FormPayloadType } from "../Setup/types";
import { BenefitsAndAllowancesType } from "../../constants";
import styles from "./ScheduleRow.module.css";

type Props = {
  setup: SetupStepData<FormPayloadType>;
};

export const ScheduleRow = ({ setup }: Props): ReactElement => {
  const schedule = getScheduleDisplayValue(setup);
  return (
    <>
      {setup.type === BenefitsAndAllowancesType.BENEFITSANDALLOWANCES && (
        <div className={styles.summaryRow}>
          <div className={styles.rowLabel}>Schedule</div>
          <div className={styles.rowValue}>{schedule}</div>
        </div>
      )}
    </>
  );
};
